/* eslint-disable max-len */

export default {
  lang: "Español",
  homeScreen: {
    title: "", // Producto específico
    stayConnected: "Mantente Conectado",
    comingSoon: "Próximamente",
    messages: "Mensajes",
    popup: {
      title: "Beneficios para graduados de Central Florida Insiders",
      body: "Asesores, les damos la bienvenida a la experiencia del Instituto de Turismo de Florida Central. Como agradecimiento, ofrecemos a los asesores que se gradúen como Insiders de Florida Central acceso a estos beneficios exclusivos.<br/><br/>Los Beneficios de Graduación de Insiders de Florida Central consisten en un paquete de regalo de graduación, una entrada de 1 día para el Parque Temático LEGOLAND®, un pase gratuito para el Museo Infantil de Florida y más ofertas y descuentos para canjear durante su visita. Gradúate primero, eso desbloqueará tu ficha exclusiva en el {Link}, donde luego podrás ir a verificar tus números IATA para acceder y obtener detalles sobre cómo canjear tus beneficios.",
      sellSection: "sección de VENTA",
    },
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Vamos a ver si podemos encontrar un perfil existente para ti en nuestro sistema.",
      homeTitleSub:
        "Ingresa la dirección de correo electrónico que usas habitualmente para iniciar sesión en programas de capacitación.",
      noAccount:
        "No se encontró ninguna cuenta ({email}), por favor intenta con otro correo electrónico o crea una cuenta ahora.",
      continueButton: "Continuar",
      success:
        "¡Cuenta actualizada exitosamente! Serás redirigido a la página de inicio en breve.",
      successNewAccount:
        "Para completar tu registro, recibirás un correo electrónico de confirmación para verificar tu cuenta.",
      loginButton: "Iniciar Sesión",
      matchFound:
        "Hemos encontrado una coincidencia, por favor ingresa tu contraseña para continuar.",
      magicLink: "Inicia sesión a través de un enlace en tu correo:",
      magicLinkButton: "Solicitar Enlace Mágico",
      magicLinkTitle:
        "Recibe un enlace directo enviado a tu correo que te permitirá iniciar sesión instantáneamente.",
      otherEmailButton: "Enviar",
      title:
        "Por favor, tómate un momento para completar toda la información a continuación, ya que esto poblará tu perfil personal e información de contacto.",
      titleIndustry:
        "Por favor, tómate un momento para completar toda la información a continuación, ya que esto poblará tu perfil personal e información de contacto.",
      register: "Crear una cuenta",
      agent: "Asesor de Viajes",
      visitor: "Visitante de la Industria",
      step1: "Paso 1: Tipo de Usuario",
      step2: "Paso 2: Crear Una Cuenta",
      step3: "Paso 3: Crear Tu Perfil",
      marketingOptIn:
        "¿Estás seguro de que no estás interesado en mantenerte conectado con el equipo de comercio de viajes de este programa?",
      optIn: "Sí, estoy interesado",
      optOut: "No estoy interesado",
      step2Sub1: "Cuéntanos Sobre Ti",
      step2Sub2: "Cuéntanos Sobre Tu Negocio",
      privacyHead: "PREFERENCIAS DE COMUNICACIÓN",
      privacySub:
        "Marca las casillas a continuación para asegurarte de recibir comunicaciones importantes del equipo de comercio de viajes del proveedor (actualizaciones de productos y anuncios, recompensas, incentivos, FAMs, etc.) e iniciativas de apoyo a la red de comercio de viajes y ventas de TravPRO Mobile.",
      privacy:
        "Protegemos tu privacidad y nunca vendemos, abusamos ni traicionamos tu confianza.",
      store: "Descarga fácilmente este programa en tu tienda de aplicaciones:",
      powered: "DESARROLLADO POR",
      toastMessage: {
        forgotSuccess:
          "¡Hemos enviado el enlace de restablecimiento de contraseña a tu correo! Serás redirigido a la página de inicio de sesión en 10 segundos.",
        emailNotExisting:
          "La dirección de correo electrónico que ingresaste no existe.",
        magicLinkMessage:
          "Por favor espera, estamos iniciando sesión ahora mismo.",
        magicLinkError:
          "No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.",
        magicLinkError1:
          "No pudimos encontrar un token válido, por favor inicia sesión o solicita un nuevo enlace mágico. Si este problema persiste, contáctanos en: info@travpromobile.com.",
        magicLinkError2:
          "No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.",
        magicLinkSuccess:
          "Revisa tu correo en {email}. Tiene un enlace mágico que te permitirá iniciar sesión.",
        magicLinkErrorWait:
          "Por favor espera 5 minutos entre solicitudes de enlace mágico.",
        emailNotFoundError:
          "La dirección de correo electrónico que ingresaste no se encuentra en nuestros registros. Por favor revisa si hay errores tipográficos o crea una cuenta.",
      },
      errors: {
        zipCodeNotFound: "Código Postal no encontrado, intenta de nuevo",
        zipCodeOnlyNumbers: "El Código Postal solo puede contener números",
        password: "Por favor ingresa una contraseña",
        passwordNotMatching: "Las contraseñas que ingresaste no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        emailExists:
          "Esta dirección de correo electrónico ya existe o es inválida. Por favor intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta.",
        fillInAllFields: "Por favor completa todos los campos requeridos",
        fillInEmail: "Por favor completa tu correo electrónico.",
        emailNotExisting:
          "La dirección de correo electrónico que ingresaste no existe.",
      },
      fields: {
        forgotSubCopy: "¿Olvidaste tu contraseña y quieres cambiarla? ",
        forgotSubCopy2:
          "¿Quieres omitir la contraseña por completo? Te enviaremos un correo con un enlace mágico que te permitirá iniciar sesión automáticamente en el programa. ",
        city: "Ciudad",
        companyName: "Nombre de la Empresa",
        role: "Tu Rol",
        description: "¿Cuál describe mejor el negocio de tu empresa?",
        country: "País",
        password: "Contraseña",
        passwordRegister: "Elige una Contraseña (mínimo de 8 caracteres)",
        passwordConfirm: "Confirmar Contraseña",
        firstName: "Nombre (de Pila)",
        lastName: "Apellido (de Familia)",
        agency: "Nombre de Tu Agencia",
        title: "Tu Rol (Selecciona Uno)",
        company: "Nombre de la Empresa",
        select: "Selecciona una opción a continuación",
        state: "Estado",
        province: "Provincia/Región/Estado",
        zipCode: "Código Postal",
        postalCode: "Código Postal",
        affiliate: "¿Cuál es la afiliación principal de tu agencia?",
        hostAgency: "¿Tu Agencia Anfitriona?",
        executive: "Ejecutivo",
        management: "Gestión",
        marketing: "Marketing",
        sales: "Ventas",
        coordinator: "Coordinador",
        other: "Otro",
        opt: "Mantente conectado con el equipo de comercio de viajes de este programa y recibe actualizaciones.",
        optMarketing:
          "Mantente conectado con TravPRO sobre programas y eventos similares.",
        retail: "Tienda Minorista",
        home: "Agente desde Casa",
        independent: "Contratista Independiente",
        host: "Agencia Anfitriona",
        call: "Centro de Llamadas o Agencia Basada en Web",
        describes: "¿Qué describe mejor a ti y al negocio de tu agencia? ",
      },
    },
    title:
      "Programa de Capacitación y Habilitación de Ventas para Profesionales de Viajes", // Producto específico (texto de TravPRO o ChannelPRO)
    welcome: {
      headerTop: "Bienvenido al",
      headerBottom: "Instituto de Turismo de Visita a Florida Central", // Producto específico
    },
    sellingPoints: {
      // Todos los puntos de venta pueden ser específicos del producto
      0: "Aprende, Promociona y Vende Sobre la Marcha",
      1: "Capacitación Multimedia a Través de Dispositivos",
      2: "Certificado de Finalización",
      3: "Presentaciones de Ventas Listas para Usar",
      4: "Materiales Promocionales de Alto Impacto",
      5: "Consejos y Promociones Exclusivas",
      6: "Directorio de Productos en Tiempo Real",
      7: "Noticias y Actualizaciones Oportunas",
    },
    emailPrompt:
      "Por favor ingresa tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.", // Producto específico (texto de TravPRO o ChannelPRO)
    tAndC: {
      agree: "Al continuar, aceptas nuestra ",
      privacyPolicy: "política de privacidad",
      and: " y ",
      termsConditions: "términos y condiciones",
    },
    fields: {
      what: "¿Qué tipo de viajes vendes?",
      what1: "¿Cuál es el tipo de viaje #1 que vendes?",
      what2: "¿Cuál es el tipo de viaje #2 que vendes?",
      what3: "¿Cuál es el tipo de viaje #3 que vendes?",
      agency: "Agencia *",
      email: "Correo Electrónico",
      password: "Contraseña",
      passwordConfirm: "Confirma tu contraseña *",
      firstName: "Nombre *",
      lastName: "Apellido *",
      agencyName: "Nombre de la Agencia *",
      city: "Ciudad *",
      stateProvince: "Estado / Provincia *",
      salutation: "Saludo *",
      required: "Requerido",
      invalidEmail: "Dirección de correo electrónico inválida",
      opt: "¡Mantente en Contacto! Sí, me gustaría recibir comunicaciones de Visita a Florida Central sobre noticias, eventos, incentivos, FAMs y más.",
      complete: "Paso 2: Completa tu perfil",
      tell: "Cuéntanos Sobre Ti",
      title: "Título del Negocio *",
      host: "Nombre de la Agencia Anfitriona",
      country: "País / Región",
      select: "Por favor selecciona una opción a continuación",
      header2: "¿Qué segmento(s) vendes principalmente?",
      step2: "Describe Tu Negocio",
      leisure: "Ocio",
      corporate: "Corporativo",
      group: "Grupo",
      affiliate: "¿Cuál es Tu Principal Afiliación?",
      forgot:
        "¿Olvidaste tu contraseña? Haz clic en el botón a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.",
    },
    noAgent: {
      noAgentButton: "No soy un asesor",
      title: "Gracias por tu interés en Visita a Florida Central.", // Producto específico
      messageWeb:
        "El contenido de este sitio es exclusivamente para profesionales de viajes. \n Para obtener más información sobre Visita a Florida Central, por favor visita: ", // Producto específico
      messageMobile:
        "Parte del contenido de esta aplicación es exclusivamente para profesionales de viajes, pero siéntete libre de explorar una vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.", // Producto específico
      continue: "Continuar",
      visitWebsite: "Visitar sitio web",
    },
    newUser: "Nuevo Usuario",
    register: "Registrarse",
    registered: "Este correo electrónico ya está registrado",
    forgot: "Restablecer Contraseña",
    header:
      "Por favor, tómate un momento para completar toda la información a continuación, ya que esto es lo que poblará tu perfil y datos de contacto.",
    step1:
      "Paso 1: Completa tu dirección de correo electrónico y elige una contraseña.",
  },
  welcomeScreen: {
    title: "Bienvenido al Instituto de Turismo de Visita a Florida Central", // Producto específico
    helloUser: "Hola {{name}}",
    hello: "Hola,",
    fromAgency: "de {{agency}}",
    notUser: "¿No eres {{name}}?",
    introOnline:
      "Entrena inmediatamente en línea o precarga el contenido para que siempre esté disponible para uso sin conexión!",
    introOffline:
      "Ya tienes la última versión precargada. ¡Comienza a entrenar o vender en cualquier momento y lugar!",
    startTraining: "Comienza a aprender",
    continueTraining: "Continúa aprendiendo",
    graduated: "¡Felicitaciones!",
    downloader: {
      preload: "Precargar",
      stop: "detener",
      init: "Inicializando...",
      lastUpdate: "Última actualización: ",
    },
  },
  trainingScreens: {
    start: "Comenzar",
    continue: "Continuar",
    review: "Revisar",
    restart: "Reiniciar",
    durationInMinutes: "{number} minutos",
    percentageComplete: "{number}% Completado",
    unlock:
      "Desbloquea este capítulo completando el capítulo de capacitación {number}.",
    unlockSubtitle:
      "Desbloquea más capítulos completando capítulos de capacitación.",
    allUnlocked: "¡Has desbloqueado todos los capítulos!",
    certificate: "Certificado",
    courseComplete: "Continuar",
    endReached: "Has llegado al final",
    retainEnd:
      "Usa la barra superior para navegar en este capítulo o presiona el botón de retroceso para volver a la vista general.",
    watchListenRead: "Mira, Escucha y Lee más",
    trouble:
      "Parece que tienes problemas, por favor vuelve a leer el contenido en la(s) página(s) anterior(es) y vuelve a intentarlo.",
    confirm: "Confirma tu respuesta",
    choose: "Por favor elige una respuesta",
    skip: "Regresar >",
    viewAllTitle: "Consejo de Capacitación",
    viewAll:
      "Para proceder a la siguiente página, haz clic en los íconos para ver el contenido suplementario. Se han proporcionado videos, mapas y otra información útil para mejorar tu capacitación y asegurarte de alcanzar el estatus de PRO.",
    fillBlanks: "Completa el(los) espacio(s) en blanco:",
    next: "Siguiente pregunta",
    retry: "Intentar de Nuevo",
    fastTrackText: {
      success:
        "¡Felicitaciones, has aprobado el curso Fast Track y desbloqueado el resto de la capacitación!",
      failed:
        "Desafortunadamente no pasaste el curso Fast Track, puedes reanudar tu capacitación para obtener tu diploma.",
    },
    fastTrack: "¡Conviértete en una Superestrella de Viajes a Suiza!",
    fastTrackExplanation:
      'Simplemente realiza el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas del cuestionario de las siguientes maneras:</span><br><br>1.	El contenido que aprendiste en los módulos de Rail Europe y Suiza<br><br>2.	Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos en detalle antes de realizar el cuestionario! Solo aquellos con las puntuaciones más altas tendrán la oportunidad de ser invitados al FAM.</span>',
    fastTrackButton:
      "Haz Clic Aquí para Realizar el Cuestionario de Superestrella Suiza",
    grading: "Tu calificación final es: {grade}%",
  },
  nav: {
    home: "Inicio",
    train: "Capacitar",
    learn: "Aprender",
    retain: "Retener",
    directory: "Directorio",
    showRoom: "Exposiciones",
    showcases: "Exposiciones",
    offers: "Ofertas",
    promote: "Promocionar",
    sell: "Vender",
    info: "Información",
    rewards: "Recompensas",
    media: "Medios",
    favorites: "Favoritos",
    contact: "Conoce al Equipo",
    reportCard: "Ver Diploma",
    accountSettings: "Configuración de Cuenta",
    messages: "Mensajes",
    search: "Buscar",
  },
  contentHeaders: {
    train: "Capacitar",
    retain: "Retener",
    subapps:
      "Módulos de Socios del Instituto de Turismo de Visita a Florida Central",
    maintrainings: "La Base",
    subtrainings: "La Experiencia",
  },
  pageDescriptions: {
    train: "Educa, compromete y conviértete en el experto.",
    showroom: "",
    retain:
      "¡Felicitaciones por completar tu capacitación! Ahora has desbloqueado tu recurso principal para retener tu conocimiento experto y habilitar tus esfuerzos de ventas. Usa esta área para responder preguntas de productos de manera experta o incluso como una presentación de ventas improvisada — en cualquier momento, en cualquier lugar y desde cualquier dispositivo.",
    promote:
      "Comparte estos elementos para generar interés y comenzar una conversación con clientes y prospectos.",
    sell: "Responde preguntas de los clientes y cierra la venta como un profesional con recursos profundos y soporte de ventas dirigido.",
    favorites: "Consulta tu contenido favorito personal",
    search: "Busca en todo el contenido",
    subapps: "",
    maintrainings:
      "Completa estos módulos esenciales para obtener tu certificado.",
    subtrainings:
      "Completa estos módulos sobre todas las increíbles cosas que los clientes pueden hacer y ver con Visita a Florida Central y recibe tu certificado como Experto del Instituto de Turismo de Visita a Florida Central.",
  },
  general: {
    next: "Siguiente",
    yes: "Sí",
    no: "No",
    previous: "Anterior",
    submit: "Enviar",
    back: "Atrás",
    close: "Cerrar",
    page: "Página",
    search: "Buscar",
    logIn: "Iniciar sesión",
    logOut: "Cerrar sesión",
    viewItem: "Ver {type}",
    imageNotFound: "Imagen no encontrada",
    noResultsFor: "No se encontraron resultados para: {{query}}",
    noFavorites: "Aún no tienes favoritos.",
    noMessages: "¡Aún no has recibido mensajes!",
    resultsFor: "Resultados para: {{query}}",
    showAll: "Mostrar todo",
    connectionError: "Error de conexión",
    alreadyExists: "Ya existe",
    pageNotFound: "¡Página 404 No Encontrada!",
    oops: "Uh oh...",
    overview: "Volver a la vista general",
    complete: "Continuar",
    courseComplete: "¡Capítulo Completo!",
    chapterComplete: "¡Capítulo Completado!",
    message: "{count} Mensaje",
    messagePlural: "{count} Mensajes",
  },
  itemTypes: {
    image: "Imagen",
    brochure: "Colección",
    layout: "Disposición",
    web: "Sitio Web",
    pdf: "PDF",
    carousel: "Colección",
  },
  questions: {
    dials: "Gira las perillas para coincidir con la respuesta",
    fitb: "Completa el(los) espacio(s) en blanco",
    flip: "Cambia el número para que coincida con la respuesta",
    multipleChoice: "Elige la(s) respuesta(s) correcta(s)",
    slider: "Elige la respuesta correcta usando el deslizador",
    map: "Responde la pregunta tocando la ubicación correcta en el mapa",
    dropdown: "Elige...",
    true: "Verdadero",
    false: "Falso",
  },
  reportCard: {
    download: "Descargar",
    email: "Correo Electrónico",
    print: "Imprimir",
  },
  cookies: {
    consent: "ACEPTAR",
    optout: "Excluir",
    settings: "Configuración de Privacidad",
    message:
      "¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Está bien, pero nos gustaría ofrecerte la mejor experiencia usando el Sales Companion.",
    disabled: "Parece que has desactivado el uso de cookies.",
    use: "La aplicación {{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.",
    details: "¿Para qué se utilizan las cookies?",
    enable: "Mira cómo habilitar tus cookies {{here}}.",
    here: "aquí",
  },
  notLoggedIn: {
    super: "No has iniciado sesión",
    title: "Necesitas iniciar sesión para ver este contenido",
    guest: "Invitado",
  },
  demo: {
    message:
      "Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.",
    consent: "¡Entendido!",
  },
  share: {
    header: "¡Comparte este recurso en tu red social favorita!",
    download: "Descargar",
  },
  sharing: {
    copyURL: "Copiar Enlace",
    copied: "Copiado",
  },
  breadCrumbs: {
    page: "Página",
  },
  onMobile: {
    header:
      "Parece que estás tratando de acceder a la aplicación {appName} desde un dispositivo móvil",
    body: "Para descargar este programa simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación",
    benefits: {
      header: "Esto te proporcionará:",
      1: "Aprende, Promociona y Vende Sobre la Marcha",
      2: "Capacitación Multimedia a Través de Dispositivos",
      3: "Certificado de Finalización",
      4: "Presentaciones de Ventas Listas para Usar",
      5: "Materiales Promocionales de Alto Impacto",
      6: "Directorio de Productos en Tiempo Real",
      7: "Noticias y Actualizaciones Oportunas",
    },
  },
  directoryView: {
    search: "Buscar...",
    amountOfResults: "Cantidad de resultados:",
    filter: "Filtrar",
    filters: "Filtros:",
    resetFilters: "Restablecer Filtros",
    showResults: "Mostrar Resultados",
    noResults:
      "No se encontraron resultados. Por favor intenta con una búsqueda diferente.",
    resetMap: "Restablecer Mapa al Inicio >",
    viewNow: "Ver Ahora >",
  },
  directory: {
    artsentertainment: "Artes y Entretenimiento",
    conventionservices: "Servicios para Convenciones",
    divingsnorkeling: "Buceo y Snorkel",
    film: "Cine",
    hotels: "Hoteles",
    lgbtgymsandspas: "LGBT+: Gimnasios y Spas",
    lgbtshopping: "LGBT+: Compras",
    lgbtwheretostay: "LGBT+: Dónde Alojarse",
    multiculturaldining: "Multicultural: Comidas",
    multiculturalnightlife: "Multicultural: Vida Nocturna",
    nightlife: "Vida Nocturna",
    petfriendly: "Amigable con Mascotas",
    restaurants: "Restaurantes",
    shopping: "Compras",
    spas: "Spas",
    sports: "Deportes",
    transportation: "Transporte",
    venues: "Lugares",
    waterways: "Vías Navegables",
    waystoplay: "Formas de Jugar",
    weddinglocations: "Lugares para Bodas",
    weddingvendors: "Proveedores de Bodas",
  },
  preregisterview: {},
  rewards: {
    rewards: "Recompensas",
    title: "RECOMPENSAS de Visita a Florida Central",
    subTitle:
      "¡Te damos la oportunidad de ganar recompensas por convertirte en especialista con nuestro programa y reservar viajes con Visita a Florida Central!",
    body: "¡Reserva viajes con Visita a Florida Central para tener la oportunidad de ganar! Ingresa tus reservas para ser elegible para ganar una Recompensa de Incentivo de Introducción de $5 US/CAN en Tarjeta de Regalo Electrónica.",
    item1:
      "Después de tu primera reserva confirmada de 4 noches o más, (para una reserva individual), para un mínimo de dos (2) pasajeros, en un hotel/resort calificado. (Los cruceros no califican).",
    item2:
      "La oferta es válida después de completar los Módulos Esenciales del Programa de Instituto de Turismo de Visita a Florida Central.",
    link1: "¿Has reservado con Visita a Florida Central? ",
    link2: "Si es así, ingresa tu reserva aquí.",
    button: "Enviar tu reserva",
    bookingForm: {
      title: "RECOMPENSAS de Visita a Florida Central",
      subTitle: "Ingresa tu reserva:",
      required: "* Indica un campo obligatorio",
      email: "Correo Electrónico del Agente",
      agentFirstName: "Nombre del Agente",
      agentLastName: "Apellido del Agente",
      company: "Nombre de la Empresa",
      iata: "IATA/CLIA #",
      stateProvince: "Estado / Provincia",
      postalCode: "Código Postal",
      country: "País",
      bookingNumber: "Número de Reserva",
      numberOfGuests: "Número de Huéspedes Adultos",
      bookingDate: "Fecha de Reserva",
      tourOperator: "Operador Turístico",
      firstName: "Nombre",
      lastName: "Apellido",
      accommodation: "Nombre del Alojamiento",
      wholesaler:
        "Nombre del Mayorista (si aplica): si es una reserva directa, ingresa NINGUNO",
      arrivalDate: "Fecha de Llegada",
      departureDate: "Fecha de Salida",
      reservationNumber: "Número de Reservación",
      rooms: "Número de Habitaciones",
      stay: "Duración de la Estancia (en Noches)",
      airline: "Aerolínea/ Transportista (código de 2 dígitos)",
      gateway: "Puerta de Origen (código de 3 letras del aeropuerto)",
      destination: "Destino / isla (código de 3 letras del aeropuerto)",
      cost: "Costo (solo usar decimales)",
      disclaimer: "* Campos obligatorios",
      button: "Enviar tu reserva",
      sub: "Tu información",
      sub2: "Información de la reserva",
    },
    TermsAndConditions: {
      title: "Términos y Condiciones",
      subTitle: "Recompensas Trimestrales para Especialistas en Bahamas",
      body1:
        "Todas las publicaciones deben ir acompañadas de un documento de prueba de venta con saldo cero que corresponda con cada reserva individual que hayas publicado. Los ganadores serán seleccionados en función de la totalidad de documentos de prueba de venta verificados que correspondan con cada reserva listada. Las publicaciones deben seguir todas las reglas de elegibilidad de Recompensas para Especialistas en Bahamas. Las recompensas no son transferibles y deben canjearse dentro de los tres (3) meses posteriores a la notificación de la recompensa. Cualquier recompensa no utilizada, no reclamada o rechazada será anulada. Las recompensas se emitirán trimestralmente y la elegibilidad se verificará en función de los viajes completados.",
      body2:
        "Para ser elegible, debes residir en EE.UU o Canadá y ser mayor de edad en el estado, provincia o territorio de residencia. Los empleados de Tour Operators NO son elegibles para sorteos y NO serán considerados para premios adicionales. Los residentes de la provincia de Quebec NO son elegibles para sorteos y NO serán considerados para premios adicionales.",
      body3:
        "La emisión de recompensas puede requerir prueba de acreditación como consejero de viajes minorista / basado en casa. Las recompensas disponibles están sujetas a cambios durante el transcurso del programa.",
      body4: "Privacidad y Uso de Información Personal",
      body5:
        "Los agentes participantes (i) otorgan al Recompensador el derecho a usar su nombre, ciudad, estado, provincia, código postal, confirmación de mayoría de edad, número de teléfono y dirección de correo electrónico para, entre otros, contactar y anunciar a los ganadores y la provisión de recompensas; (ii) otorgan al Recompensador el derecho a usar su información personal con fines publicitarios y promocionales relacionados con las recompensas, en cualquier y todos los medios ahora conocidos o que se inventen en el futuro, sin compensación adicional a menos que lo prohíba la ley; y (iii) reconocen que el Recompensador puede divulgar su información personal a terceros agentes y proveedores de servicios en relación con cualquiera de las actividades mencionadas en (i) y (ii) anteriores.",
      button: "Volver a la página de inicio",
    },
    thankYouPage: {
      thanks: "Gracias",
      congrats: "Felicidades, ",
      body: "tu reserva ha sido recibida y enviada al supervisor de la campaña para su verificación.",
      link: "Por favor, ten en cuenta que para ser un ganador, debes haber completado los Módulos Esenciales del Programa de Especialistas en Bahamas.",
    },
  },
  custom: {
    splitUsers: "Soy un ...",
    brandAmbassador: "Embajador de Marca",
    travelPro: "Profesional de Viajes",
  },
};
